import React, { useContext } from 'react';

/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { Page } from '../Components/Page';
import { RunningReactCode } from '../Components/RunningReactCode';
import { TagButton } from '@tag/tag-components-react-v3';
import { Code } from '../Components/CodePreview/Code';
import { darkModeContext } from '../darkModeContext';

export const PlayPage = () => {
  const [code, setCode] = React.useState('');
  const [exampleCode, setExampleCode] = React.useState('');

  const docsDarkMode = useContext(darkModeContext);
  const docsDarkModeValue = docsDarkMode.value || false;

  const singleComponentExample = `<TagButton text="Click me"></TagButton>`;
  const multiComponentExample = `{
  const [value, setValue] = React.useState(2);
  return (
    <React.Fragment>
      <TagForm>
        <TagFormGroup>
          <TagEditField
            label='Comments'
            value={value}
            onValueChange={e => setValue(e.detail.value)}
          />
        </TagFormGroup>
      </TagForm>
    </React.Fragment>
  )
}`;
  return (
    <Page title="Play">
      <p>
        Unfortunately, we can't use CodePen, CodeSandbox, ... for React code that consumes the React
        tag-components because the npm package is only available on the internal Access network. So,
        this is a simple tool to run React code that consumes the React tag-components.
      </p>
      <p>
        It's great for trying things out or reproducing problems ... just paste and tweek your code
        in the box below and see the result ...
      </p>
      <textarea
        placeholder="Enter your React code ..."
        value={code}
        onChange={e => setCode(e.currentTarget.value)}
        css={css`
          font-family: Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace;
          background-color: #272822;
          color: #dedede;
          font-size: 0.9em;
          white-space: pre;
          word-spacing: normal;
          word-break: normal;
          word-wrap: normal;
          line-height: 1.5;
          tab-size: 4;
          width: 100%;
          min-height: 200px;
          padding: 15px 10px;
          :focus {
            outline: none;
          }
        `}
      />
      <TagButton
        text="Render"
        accent="access"
        onButtonClick={() => setExampleCode('Example = () => ' + code)}
      />
      <div
        css={css`
          box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px;
          margin: 30px 0px;
          padding: 30px;
          background: ${docsDarkModeValue ? '#272822' : 'rgb(255, 255, 255)'};
          border-width: 1px;
          border-style: solid;
          border-color: rgba(0, 0, 0, 0.1);
          border-radius: 4px 4px 0px 0px;
        `}
      >
        {exampleCode && (
          <RunningReactCode
            parentJSX={exampleCode}
            jsx={'<Example />'}
            backgroundVisible={false}
            knobs={{}}
            knobValues={{}}
            events={[]}
          />
        )}
      </div>
      <h3>Tips</h3>
      <div>
        You can have a single component. e.g.
        <Code code={singleComponentExample}></Code>
      </div>
      <div>
        ... or you can have multiple components / use Reacts hooks / ... by putting the code in
        curley brackets e.g.
        <Code code={multiComponentExample}></Code>
      </div>
    </Page>
  );
};
